import React from 'react';

const shimmerDelay = (ms) => ({'--shimmer-delay': `${ms}ms`});

function ContactListSkeleton({count = 7}) {
    return (
        <div className="sms-skeleton contact-list-container" style={{flex: 1, overflowY: 'auto', minHeight: 0}}>
            <div className="list-group list-group-flush">
                {Array.from({length: count}).map((_, index) => {
                    const delay = index * 60;
                    return (
                        <div
                            key={index}
                            className="list-group-item border-0 rounded mb-1 p-3 skeleton-item"
                            style={{animationDelay: `${delay}ms`}}
                        >
                            <div className="d-flex align-items-start">
                                <span
                                    className="skeleton-block skeleton-circle flex-shrink-0"
                                    style={{width: 48, height: 48, ...shimmerDelay(delay + 40)}}
                                />
                                <div className="flex-fill ms-3" style={{minWidth: 0}}>
                                    <div className="d-flex justify-content-between align-items-start mb-2">
                                        <span
                                            className="skeleton-block"
                                            style={{height: 14, width: '58%', ...shimmerDelay(delay + 80)}}
                                        />
                                        <span
                                            className="skeleton-block ms-2"
                                            style={{height: 12, width: '22%', ...shimmerDelay(delay + 100)}}
                                        />
                                    </div>
                                    <span
                                        className="skeleton-block mb-2 d-block"
                                        style={{height: 12, width: '42%', ...shimmerDelay(delay + 120)}}
                                    />
                                    <span
                                        className="skeleton-block d-block"
                                        style={{height: 12, width: '78%', ...shimmerDelay(delay + 140)}}
                                    />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default ContactListSkeleton;
